export const POINT_DETAILS_INFO_WINDOW_MS = 6000;

export function pointDetailsInfoWindowHtml({
  t,
  weatherHtml,
  speed,
  timeLabel,
  relativeTime,
  showMore = false,
} = {}) {
  const translate = t || ((text) => text);
  const speedText = speed == null || speed === "" ? "—" : speed;

  return (
    '<div class="agri-point-details-iw">' +
    (weatherHtml || "") +
    '<div class="agri-point-details-iw__row"><strong>' +
    translate("Velocidade") +
    ":</strong> " +
    speedText +
    "</div>" +
    '<div class="agri-point-details-iw__row"><strong>' +
    translate("Período") +
    ":</strong> " +
    (timeLabel || "—") +
    "</div>" +
    (relativeTime
      ? '<div class="agri-point-details-iw__rel">' + relativeTime + "</div>"
      : "") +
    (showMore
      ? '<div class="agri-point-details-iw__more">' +
        '<div id="obs-btn" class="agri-point-details-iw__more-btn" title="' +
        translate("Ver mais") +
        '">' +
        '<span class="agri-point-details-iw__eye">&#128065;</span>' +
        translate("Ver mais") +
        "</div></div>"
      : "") +
    "</div>"
  );
}
